// WaterMass.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
const TITLE = "Kalkulator Massa Air - Hitung Massa Air Berdasarkan Volume dan Massa Jenis Air";
const DESCRIPTION =
  "Kalkulator massa air yang akurat: hitung massa air (dalam gram atau kilogram) dengan mudah! Masukkan volume air (liter, mililiter, m³) dan suhu (untuk menyesuaikan massa jenis) untuk mendapatkan hasil instan - penting untuk kimia, fisika, dan teknik.";
const KEYWORDS = "massa air, hitung massa air, kalkulator massa air";
const OG_URL = "https://do-calculate.com/calculator/id/water-mass/";
function Calculator() {
  const [waterVolume, setWaterVolume] = useState("");
  const [waterMass, setWaterMass] = useState("");
  const [error, setError] = useState("");
  const waterDensity = 1000;
  const handleCalculate = () => {
    if (!waterVolume) {
      setError("Harap masukkan volume air dalam meter kubik dengan benar");
      setWaterMass("");
      return;
    }
    const volumeValue = parseFloat(waterVolume);
    if (isNaN(volumeValue) || volumeValue < 0) {
      setError("Harap masukkan nilai yang valid dan tidak negatif untuk volume air dalam meter kubik");
      setWaterMass("");
      return;
    }
    const mass = volumeValue * waterDensity;
    setWaterMass(mass.toFixed(2));
    setError("");
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <h2 style={{ fontSize: "18px" }}>Cara Menghitung Massa Air</h2>
                <p>
                  Untuk menghitung massa air, digunakan hubungan antara volume dan massa jenis air. Anda harus memasukkan volume air dalam satuan meter kubik, kemudian volume ini dikalikan dengan massa jenis air untuk mendapatkan massa dalam satuan kilogram.
                </p>
                <p>
                  <strong>Rumus Perhitungan:</strong> <br />
                  Massa Air = Volume (meter kubik) × Massa Jenis Air (kilogram/meter kubik)
                </p>
                <p>
                  Anda dapat menggunakan kalkulator ini untuk menentukan massa air secara akurat berdasarkan nilai yang Anda masukkan. Cukup masukkan volume dan massa jenis, dan Anda akan mendapatkan hasil dengan cepat dan mudah.
                </p>
                <b >
                  Tanggal Pembaruan Terakhir:{" "}
                  <time dateTime="2026-01-10">28/02/2026</time>
                </b>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                </div>
                <hr />
                <div >
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          Volume Air (meter kubik)
                        </label>
                      </b>
                      <input
                        type="number"
                        placeholder="Volume air dalam meter kubik"
                        value={waterVolume}
                        onChange={(e) => setWaterVolume(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      Hitung Massa Air
                    </button>
                  </div>
                  <br />
                  <div>
                    {error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        Error: {error}
                      </p>
                    ) : (
                      <>
                        {waterMass !== "" && (
                          <>
                            <p className="p-3 mb-2 bg-success text-white">
                              Massa Air: {waterMass} kilogram
                            </p>
                            <p className="p-3 mb-2 bg-info text-black">
                              Nilai ini mewakili massa air berdasarkan volume yang Anda masukkan dan massa jenis air.
                            </p>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="col-12 col-md-8">
        <div className="info-sections-container">
          <div className="info-section">
            <div className="info-section-header">
              <h2 style={{ fontSize: "18px" }}>{TITLE}</h2>
            </div>
            <div className="info-section-body">
              <p>{DESCRIPTION}</p>
              <div>
                <h3 style={{ fontSize: '16px' }}>Cara Menghitung Massa Air</h3>
                <p>Untuk menghitung massa air, Anda perlu mengetahui volume air dan massa jenis air. Ikuti langkah-langkah berikut:</p>
                <ul>
                  <li><strong>Masukkan volume air:</strong> Volume diukur dalam meter kubik (m³).</li>
                  <li><strong>Masukkan massa jenis air:</strong> Massa jenis umum air adalah 1000 kilogram per meter kubik (kg/m³).</li>
                </ul>
                <p>Kemudian massa dihitung menggunakan rumus berikut:</p>
                <p><strong>Massa Air = Volume (meter kubik) × Massa Jenis Air (kilogram/meter kubik)</strong></p>
                <p>Rumus ini didasarkan pada massa jenis air yang konstan, yaitu sekitar 1000 kg/m³ pada suhu kamar.</p>
              </div>
              <hr />
              <div>
                <h3 style={{ fontSize: '16px' }}>Contoh Perhitungan Massa Air</h3>
                <p>Misalkan Anda ingin menghitung massa 2 meter kubik air. Menggunakan massa jenis air yang konstan, kita lakukan:</p>
                <div className='p-3 mb-2 bg-info'>
                  <strong>Massa Air = Volume × Massa Jenis Air = 2 m³ × 1000 kg/m³ = 2000 kg</strong>
                </div>
                <p>Dalam contoh ini, massa air adalah 2000 kilogram. Anda dapat menggunakan kalkulator ini untuk menentukan massa air untuk volume berapa pun yang Anda tentukan.</p>
              </div>
              <hr />
              <div>
                <h3 style={{ fontSize: '16px' }}>Tips Menghitung Massa Air</h3>
                <p>Pastikan untuk memasukkan volume air dalam jumlah yang benar, dan pastikan untuk menggunakan massa jenis air yang sesuai. Massa jenis air dapat bervariasi berdasarkan suhu, tetapi nilai yang digunakan dalam contoh ini sesuai dengan massa jenis standar pada suhu kamar. Untuk informasi lebih lanjut tentang penggunaan kalkulator ini dan aplikasi praktisnya, Anda dapat merujuk pada sumber-sumber berikut:</p>
                <ul>
                  <li><a href="https://www.engineeringtoolbox.com/water-density-specific-weight-d_595.html" rel="nofollow noreferrer" target="_blank">Engineering ToolBox - Water Density</a></li>
                </ul>
                <p>Kalkulator ini dikembangkan berdasarkan prinsip dan data tepercaya dari sumber-sumber yang disebutkan di atas.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Calculator;